/**
 * Video Embed component for displaying video content.
 * It checks if the provided URL is a valid video URL and renders an embedded video player or checks for a valid
 * embed HTML snippet.
 */
import React from "react";
import { Box } from "@mui/material";
import { isVideoUrl } from "@smfa/utils/src";

/**
 * @param {string} param0.urlOrEmbed - The video URL or embed HTML snippet
 * @returns {JSX.Element} VideoEmbed component
 * @component
 */
const VideoEmbed = ({ urlOrEmbed, title = "Video" }) => {
  return isVideoUrl(urlOrEmbed) ? (
    <Box
      sx={{
        position: "relative",
        pb: "56.25%",
        height: 0,
        mb: 2,
      }}
    >
      <iframe
        src={urlOrEmbed}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          borderRadius: 8,
          border: "none",
        }}
      />
    </Box>
  ) : (
    <Box sx={{ width: "100%", maxWidth: 900, mx: "auto", mb: 2 }}>
      <div
        dangerouslySetInnerHTML={{
          __html: urlOrEmbed,
        }}
      />
    </Box>
  );
};

export default VideoEmbed;
